import { render, staticRenderFns } from "./Tag-In-Out-Detail.vue?vue&type=template&id=229a1678&"
import script from "./Tag-In-Out-Detail.vue?vue&type=script&lang=ts&"
export * from "./Tag-In-Out-Detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports